import { ApiService } from 'services';
import { AuthState } from '../auth/common';

export const AUTH_STATE_REQUEST = 'AUTH_STATE_REQUEST';
export const AUTH_STATE_SUCCESS = 'AUTH_STATE_SUCCESS';

function request() {
  return {
    type: AUTH_STATE_REQUEST,
    authState: AuthState.Requesting,
  };
}

function receive(data) {
  return {
    type: AUTH_STATE_SUCCESS,
    authState: data.authState,
  };
}

export function getAuthState() {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getAuthState()
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
      });
    return promise();
  };
}
